import I18n from './I18n';
import I18nManager from './I18nManager';

export const i18ns = new I18nManager();

export default I18n;
